import { render, staticRenderFns } from "./Areaofinterest.vue?vue&type=template&id=74b64fa8&scoped=true&"
import script from "./Areaofinterest.vue?vue&type=script&lang=js&"
export * from "./Areaofinterest.vue?vue&type=script&lang=js&"
import style0 from "./Areaofinterest.vue?vue&type=style&index=0&id=74b64fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b64fa8",
  null
  
)

export default component.exports